interface StepDisabledStyle {
  background: string;
}

interface StepActiveStyle {
  activeClassName: string;
  iconBgClassName: string;
  stepActiveClassName: string;
}

interface StepData extends StepDisabledStyle, StepActiveStyle {}

type StepColor = (typeof StepColors)[keyof typeof StepColors];

const StepColors = {
  Blue: '#AE7DF2',
  Green: '#01BF9C',
  Accent: '#0186BF',
  Orange: '#F67B43',
  Purple: '#E745D4',
} as const;

const disabledStyles: Record<StepColor, StepDisabledStyle> = {
  [StepColors.Accent]: {
    background: 'linear-gradient(140.14deg, #E6F3F9 0%, #E6F9F6 100%)',
  },
  [StepColors.Blue]: {
    background: 'linear-gradient(154.27deg, #F7F2FF -12.3%, #D3E1EE 87.56%)',
  },
  [StepColors.Green]: {
    background: 'linear-gradient(154.27deg, #B4DED6 -12.3%, #EDF0E6 87.56%)',
  },
  [StepColors.Orange]: {
    background: 'linear-gradient(154.27deg, #F6E5DD -12.3%, #FFFBE8 87.56%)',
  },
  [StepColors.Purple]: {
    background: 'linear-gradient(154.27deg, #FDEAFB -12.3%, #F5E7FF 87.56%)',
  },
};

const activeStyles: Record<StepColor, StepActiveStyle> = {
  [StepColors.Blue]: {
    iconBgClassName: 'bg-blue-gradient-light',
    activeClassName: 'bg-blue-gradient-primary',
    stepActiveClassName: 'bg-blue-gradient-primary',
  },
  [StepColors.Green]: {
    iconBgClassName: 'bg-green-gradient-light',
    activeClassName: 'bg-green-gradient-primary',
    stepActiveClassName: 'bg-green-gradient-dark',
  },
  [StepColors.Purple]: {
    iconBgClassName: 'bg-purple-gradient-light',
    activeClassName: 'bg-purple-gradient-primary',
    stepActiveClassName: 'bg-purple-gradient-dark',
  },
  [StepColors.Orange]: {
    iconBgClassName: 'bg-orange-gradient-light',
    activeClassName: 'bg-orange-gradient-primary',
    stepActiveClassName: 'bg-orange-gradient-primary',
  },
  [StepColors.Accent]: {
    activeClassName: 'bg-accent-gradient-primary-primary',
    iconBgClassName: 'bg-accent-gradient-secondary-primary',
    stepActiveClassName: 'bg-accent-gradient-primary-primary',
  },
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getStepData = (color: string, codeName: string): StepData => {
  const disabled = disabledStyles[color as StepColor] || {
    background: `linear-gradient(135deg, ${color} 0%, ${color} 100%)`,
  };
  const active = activeStyles[color as StepColor] || {
    activeClassName: 'bg-accent-gradient-primary-primary',
    iconBgClassName: 'bg-accent-gradient-secondary-primary',
    stepActiveClassName: 'bg-accent-gradient-primary-primary',
  };
  return {
    ...active,
    ...disabled,
  };
};
